import {
  OverflowMenu as CarbonOverFlowMenu,
  OverflowMenuItem
} from 'carbon-components-react'
import './index.scss'

import withUbliqueStyle from '../UbliqueStyle'

const OverflowMenu = withUbliqueStyle(
  CarbonOverFlowMenu,
  'ublique-overflow-menu'
)

OverflowMenu.Item = OverflowMenuItem

export { OverflowMenu, OverflowMenuItem, OverflowMenu as default }
